/*eslint-disable*/
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CustomMaterialTable from '../../../Component/CustomMaterialTable';
import DropDown from '../../../Component/DropDown/DropDown';
import SearchInput from '../../../Component/SearchInput';
import SideBarSkeleton from '../../../Component/SideBarSkeleton';
import { recordsLimit } from '../../../config/apiUrl';
import { dateFilterOptions } from '../../../constant/commonData';
import useDebounce from '../../../CustomHooks/useDebounce';
import { useGetMyFollowersQuery } from '../../../store/apiSlice/apiSlice';
import classes from './Followers.module.css';

function Followers() {
  const [searchText, setSearchText] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [dateFilter, setDateFilter] = useState(dateFilterOptions[0]);
  const debouncedSearchTerm = useDebounce(searchText, 500);
  const [limit, setLimit] = useState(recordsLimit);
  const [page, setPage] = useState(1);

  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { t } = useTranslation('dashboardFollowers');

  const { data, isLoading, isFetching } = useGetMyFollowersQuery({
    limit,
    page,
    search: debouncedSearchTerm,
    sortBy: dateFilter?.value
  });
  const headings = [
    { id: 'id', label: t('sNo'), renderValue: (_, __, i) => i + 1 },
    { id: 'fullName', label: t('followerName') },
    { id: 'email', label: t('email') }
    // { id: 'phoneNumber', label: t('mobile') }
  ];

  return (
    <SideBarSkeleton>
      <Container fluid className={classes.page}>
        <Row>
          <Col md={12} className={classes.mb58}>
            <div className={classes.header}>
              <div className={classes.left}>
                <SearchInput
                  placeholder={t('searchByName')}
                  setter={setSearchText}
                  state={searchText}
                  variant="dashboard"
                  containerStyle={{
                    width: '300px',
                    border: '1px solid black',
                    overflowY: 'hidden'
                  }}
                />
                <DropDown
                  label={t('sortByDate')}
                  containerClassName={classes.dropDownContainer}
                  customStyle={{
                    padding: '0px 6px',
                    //  minHeight: '40px',
                    minWidth: '200px'
                  }}
                  value={dateFilter}
                  options={dateFilterOptions}
                  setValue={(e) => {
                    setDateFilter(e);
                  }}
                  getOptionLabel={(e) => e?.[selectedLanguage]}
                  placeholder={'Select Date'}

                  // isClearable={true}
                />
              </div>
            </div>
          </Col>
          <Col md={12}>
            <h5 className={classes.heading}>{t('followers')}</h5>
          </Col>
          <Col md={12}>
            <CustomMaterialTable
              headings={headings}
              data={data?.data}
              totalRecords={Math.ceil(data?.totalRecords / recordsLimit)}
              isLoading={isLoading || isFetching}
              page={page}
              limit={recordsLimit}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              allowMultipleSelection={false}
              rowsPerPage={limit}
              setRowsPerPage={setLimit}
              setPage={setPage}
              showOptionsColumn={false}
            />
          </Col>
        </Row>
      </Container>
    </SideBarSkeleton>
  );
}

export default Followers;
